import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchAllocations,
  fetchAllocationStatistics,
  initialFilters
} from 'ducks/allocations';
import {withFilters, FILTERS} from 'components/withFilters';

import {ArchiveRoomForm, Buttons} from './components';

class ArchiveRoomModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('archiveRoom');

  getExtraActions = () => {
    const {locationRef} = this.props.data;
    return [
      () => this.props.clearFilters(),
      () => fetchAllocations({locationRef}),
      () => fetchAllocationStatistics({locationRef}),
      ...this.props.closeModalExtraActions
    ];
  };

  render() {
    const {closeModal, form: {submitting}, data: {locationRef}} = this.props;
    return (
      <Modal
        modalOverlayClassName="ArchiveRoomModalOverlay"
        className="ArchiveRoomModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Archive Room" />
        <Modal.Body>
          <ArchiveRoomForm
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            closeModal={closeModal}
            triggerSubmit={this.triggerSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('archiveRoom')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withFilters(
    withModal(MODALS.ARCHIVE_ROOM)(ArchiveRoomModal),
    FILTERS.ALLOCATIONS_CALENDAR,
    {initialFilters, clearFiltersOnUnmount: false}
  )
);
